export default __webpack_public_path__ + "static/media/skovstykket-townhouse-6-rooms-10.b224459d.jpg";